/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIWorkHour
 */
export interface APIWorkHour {
    /**
     * 
     * @type {string}
     * @memberof APIWorkHour
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIWorkHour
     */
    weekday?: string;
    /**
     * 
     * @type {string}
     * @memberof APIWorkHour
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof APIWorkHour
     */
    endTime?: string;
}

/**
 * Check if a given object implements the APIWorkHour interface.
 */
export function instanceOfAPIWorkHour(value: object): value is APIWorkHour {
    return true;
}

export function APIWorkHourFromJSON(json: any): APIWorkHour {
    return APIWorkHourFromJSONTyped(json, false);
}

export function APIWorkHourFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIWorkHour {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'weekday': json['weekday'] == null ? undefined : json['weekday'],
        'startTime': json['start_time'] == null ? undefined : json['start_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
    };
}

export function APIWorkHourToJSON(value?: APIWorkHour | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'weekday': value['weekday'],
        'start_time': value['startTime'],
        'end_time': value['endTime'],
    };
}

